import axios from "axios";

const api = axios.create({
  baseURL: "https://api.navrititech.com/api", // 👈 set backend base URL once
// baseURL: "http://localhost:5000/api",
});

export default api;